<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
window._czc = window._czc || [];
export default {
  name: 'app',
  mounted () {
    const script = document.createElement('script')
    script.src = 'https://s4.cnzz.com/z_stat.php?id=1278736774&web_id=1278736774'
    script.language = 'JavaScript'
    document.body.appendChild(script)
  }
  // watch: {
  //   '$route' () {
  //     if (window._czc) {
  //       window._czc.push(['_trackEvent', '软件', '下载','番茄听书','1','download'])
  //     }
  //   }
  // }
}
</script>


<style lang="stylus" rel="stylesheet/stylus">
  #app
    width 100%
    height 100%

</style>
